module.exports = __webpack_public_path__ + "fonts/Nunito-Italic.588dd67d.ttf";